import script from "./ProceedQuotation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceedQuotation.vue?vue&type=script&setup=true&lang=js"

import "./ProceedQuotation.vue?vue&type=style&index=0&id=aef3fb28&lang=css"

const __exports__ = script;

export default __exports__